module.exports = __webpack_public_path__ + "static/media/nl.feb9eea9.svg";